import { toJS } from "mobx";
import staticEndPoints from "../../api/endPoints/staticEndpoints";

const calculateColors = (pdpColors, colorDetails) => {
  const pcmColorArray = [colorDetails];
  const pcmColors = {
    "": pcmColorArray,
  };
  if (pdpColors && pdpColors.colors && pdpColors.total > 0) {
    return pdpColors.colors;
  }
  return pcmColors;
};

const getPdpDetails = PdpData => {
  if (PdpData) {
    const { colors: pdpColors, mainStyle } = toJS(PdpData);
    const {
      skus,
      images = [
        {
          thumbnail: staticEndPoints.noImg,
          large: staticEndPoints.noImg,
          medium: staticEndPoints.noImg,
        },
      ],
      inStock,
      colorDetails,
      discountRange,
      mrpRange,
      isNew,
      sellingPriceRange,
      promotions,
      styleId,
      quantity,
      url,
      brandName,
      name,
      sizeChartId,
      story,
      brandClickableUrl,
    } = mainStyle;
    const [image] = images;
    const colors = calculateColors(pdpColors, colorDetails);
    let selectedSku = {};
    if (skus && skus.length === 1) {
      [selectedSku] = skus;
    }
    return {
      skus,
      colors,
      inStock,
      discountRange,
      mrpRange,
      sellingPriceRange,
      isNew,
      promotions,
      brandName,
      name,
      images,
      quantity,
      url,
      colorDetails,
      image,
      brandText: brandName,
      styleId,
      sizeChartId,
      story,
      selectedSku,
      brandClickableUrl,
    };
  }

  return {
    isNew: false,
    inStock: false,
    colors: {},
    skus: [],
    promotions: [],
    brandName: "",
    name: "",
  };
};

const getCollectionIdFromState = () =>
  (window &&
    window.history &&
    window.history.state &&
    window.history.state.state &&
    window.history.state.state.collectionId) ||
  "";

const filterInThisLookByBrands = (items, legalBrandNames) => {
  // legalBrandNames = ["GAP"];
  if (legalBrandNames && legalBrandNames.length) {
    const filteredList = items.filter(item =>
      legalBrandNames.includes(item.brandName),
    );
    return filteredList;
  }
  // console.log("WWWWWWWWWW");
  // console.log(filteredList);
  return items;
};

const Methods = {
  calculateColors,
  getPdpDetails,
  getCollectionIdFromState,
  filterInThisLookByBrands,
};

export default Methods;



// WEBPACK FOOTER //
// ./src/stores/ProductStore/methods.js